/**
 * Function that gives the default departure, pickup and return dates in requested format for flight, car, and hotel form types.
 *
 * @param fieldName - string
 * @param dateFormat - string such as "MM/DD/YYYY or "YYYY-MM-DD" etc.
 * @returns: string in requested format.
 */
import { swaDate } from "@swa-ui/date";

const DEFAULT_DATE_OFFSET = 1;
const DEFAULT_RETURN_DATE_OFFSET = 4;
const fieldNames = ["checkinDate", "departureDate", "pickupDate"];

export const getDefaultDate = (fieldName, dateFormat) => {
  const dateOffset = fieldNames.includes(fieldName)
    ? DEFAULT_DATE_OFFSET
    : DEFAULT_RETURN_DATE_OFFSET;

  return swaDate()
    .set("date", swaDate().get("date") + dateOffset)
    .format(dateFormat);
};
